// adjust in BQ views if needed
const MacroTerritories = [
	{"name": "Overview", "overview": true,  "primaryCountries": []},
	{"name": "North America", "primaryCountries": ["US", "CA", "MX"]},
	{"name": "Europe", "primaryCountries": ["GB", "DE", "FR"]},
	{"name": "Asia", "primaryCountries": ["JP", "KR", "CN"]},
	{"name": "Oceania", "primaryCountries": ["AU", "NZ"]},
	{"name": "South America", "primaryCountries": ["BR", "CL", "AR"]},
	{"name": "Africa", "primaryCountries": ["ZA", "EG", "MA"]}
]

export default MacroTerritories;